import React, { useEffect } from 'react';
import { BoookingPage } from '../BookingComponents/BoookingPage';

export const Booking = () => {
    useEffect(() => {
        // Set the id of the body element when the component mounts
        document.body.id = 'bookingBody';
        // Remove the id when the component unmounts
        return () => {
            document.body.id = '';
        };
    }, []);

    return (
        <div>
            <BoookingPage />
        </div>
    );
};

export default Booking;
